import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { useDatasetError } from '../types/types';
import { requestFilter } from '../requests/filters/requestFilter';

export type useFilterRes = { datasetId: string; filter: any } | undefined;

export const useFilter = () => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<useDatasetError>(undefined);
  const [data, setData] = useState<useFilterRes>(undefined);
  const handleApiError = useApiErrorHandling();

  const fetch = async (
    api: string,
    datasetId: string,
    forceHeader?: string
  ) => {
    let res;
    try {
      setIsLoading(true);
      setData(undefined);
      setError(undefined);
      res = await requestFilter(api, token, forceHeader);

      const data = { filter: res, datasetId };
      setData(data);
      return data;
    } catch (e) {
      if (e instanceof Error) setError({ error: e, datasetId });
      handleApiError(e, true, (forceHeader) =>
        requestFilter(api, token, forceHeader)
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    data,
    fetch,
  };
};
